exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#exception-container {\n  height: 500px;\n  overflow-y: scroll;\n}\n", ""]);

// exports
